import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";

const Staffmiddleware = (props: any) => {
  const [isAdmin, setIsAdmin] = useState<string>();
  const navigate = useNavigate();

  useEffect(() => {
    const getAuthUser = localStorage.getItem("authUser");
    if (getAuthUser) {
      const obj = JSON.parse(getAuthUser);
      // if (obj.role !== "AD") {
      //   navigate("/login");
      // }
    }
  }, []);

  return <React.Fragment>{props.children}</React.Fragment>;
};

export default Staffmiddleware;
